import React, { useState } from 'react';
import './Auth.css';
import { getPrivateKey } from './utils/indexedDBManager';

function Login({ onLoginSuccess, onSwitchToRegister }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Check if private key exists in IndexedDB
            const privateKey = await getPrivateKey();

            if (!privateKey) {
                setMessage("No encryption keys found. Please register first or use the same browser where you registered.");
                return;
            }

            console.log("Private key found in IndexedDB");

            const response = await fetch('https://encrypted-chat-application-uh5z.onrender.com/api/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ username, password }),
            });

            const result = await response.text();

            if (response.ok) {
                setMessage(result);
                onLoginSuccess(username);
            } else {
                setMessage(result);
            }
        } catch (error) {
            setMessage('Error: ' + error.message);
        }
    };

    return (
        <div className="auth-box">
            <h2>Login</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Username"
                    required
                />
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required
                />
                <button type="submit">Login</button>
            </form>

            {message && <p className="message">{message}</p>}
            <p className="register-link">
                Don't have an account?{" "}
                <span
                    onClick={onSwitchToRegister}
                    style={{ color: "#00aaff", cursor: "pointer", fontWeight: "bold" }}
                >
                    Register
                </span>
            </p>
        </div>
    );
}

export default Login;